export default "/images/80422846a3fd47fb480b89140c32b8b7.avif";